import { SEO_TITLE_LOGIN } from 'mk/autogenerated/translations/LoginPage.17e967995c692adc9018cda08ff8d047'
import { LoginFormData, LOGIN_FORM_NAME } from 'mk2/apps/users/components/LoginForm';
import Login from 'mk2/apps/users/containers/Login/Login';
import { checkOneTimeLoginLinkTrigger, loginTrigger } from 'mk2/apps/users/containers/Login/Login.actions';
import loginSaga from 'mk2/apps/users/containers/Login/Login.sagas';
import { SIGNUP_FORM_NAME } from 'mk2/apps/users/containers/Signup/Signup.constants';
import { loginUrl } from 'mk2/apps/users/urls';
import { loginSignupTabs } from 'mk2/apps/users/utils';
import { AppName } from 'mk2/containers/Application/Application';
import { mkReduxFormMapDispatchToProps, mkReduxFormMapStateToProps } from 'mk2/decorators/mkReduxForm';
import { cachedInitialValues } from 'mk2/helpers/form';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import FormPage, { FormPageDispatchProps, FormPageStateProps } from 'mk2/pages/FormPage';
import { getRequestDeviceMobile, getRequestLastKnownUsername, AppState } from 'mk2/reducers';
import { HeaderMenuItem, MenuSelection } from 'mk2/schemas';
import { Store } from 'mk2/store/configureStore';
import { parse } from 'query-string';
import React from 'react';
import { MapStateToPropsParam } from 'react-redux';
import { RouteComponentProps } from 'react-router';

interface OwnProps {}

interface StateProps extends FormPageStateProps {
    initialValues: LoginFormData;
    isMobile: boolean;
}

interface DispatchProps extends FormPageDispatchProps {
    onCheckOneTimeLoginLink(otlHash: string);
    onLogin(values: LoginFormData);
}

type RouteProps = RouteComponentProps<{}>;

export type Props = OwnProps & StateProps & DispatchProps & RouteProps;

export default class LoginPage extends FormPage<OwnProps & RouteProps, StateProps, DispatchProps> {

    public mapStateToProps(): MapStateToPropsParam<StateProps, OwnProps & RouteProps, AppState> {
        return (state: AppState, ownProps: OwnProps & RouteProps): StateProps => {
            const { location } = ownProps;

            const query = parse(location.search);
            const username = query.username
                ? (query.username as string).toLowerCase()
                : getRequestLastKnownUsername(state);

            return {
                ...mkReduxFormMapStateToProps(LOGIN_FORM_NAME)(state),

                initialValues: cachedInitialValues(LOGIN_FORM_NAME, {
                    username: username || '',
                    password: '',
                }, username),
                isMobile: getRequestDeviceMobile(state),
            };
        };
    }

    public mapDispatchToProps(): MapDispatchToPropsObject<DispatchProps> {
        return {
            ...mkReduxFormMapDispatchToProps(SIGNUP_FORM_NAME),
            onLogin: loginTrigger,
            onCheckOneTimeLoginLink: checkOneTimeLoginLinkTrigger,
        };
    }

    public getMetaTitle(props: Props): string {
        return SEO_TITLE_LOGIN;
    }

    public render(props: Props): false | JSX.Element {
        return (
            <Login {...props} />
        );
    }

    public hasPageHeaderPart1(props: Props): boolean {
        const { isMobile } = props;
        return isMobile;
    }

    public hasHeaderBackButton(props: Props): boolean {
        return false;
    }

    public getHeaderTabs(props: Props): (JSX.Element[] | null) {
        const { isMobile } = props;
        if (isMobile) {
            return loginSignupTabs('login');
        }
    }

    public getHeaderMenuSelection(app: AppName, props: Props): MenuSelection {
        return {
            activeSection: app,
            activeItem: HeaderMenuItem.UserLogin,
        };
    }

    public hasMobileLogo(): boolean {
        return true;
    }

    public getSubmitButton(props: Props): React.ReactElement {
        return null;
    }

    public getMetaRobots(props: Props): string {
        if (props.location.search !== '') {
            return 'noindex,nofollow';
        }

        return super.getMetaRobots(props);
    }

    public getCanonicalUrl(baseUrl: string, props: Props): string {
        return baseUrl + loginUrl;
    }

    public registerInStore(store: Store<AppState>) {
        // store.injectReducer('containers.users.login', loginReducer);
        store.injectSaga('containers.users.login', loginSaga);
    }
}
